import * as React from 'react';
import { connect } from 'react-redux';

import Product from '../../components/Product/Product';
import ProductList from '../ProductList/ProductList';
import { useHistory } from 'react-router-dom';

import * as Const from '../../constants';
import ErrorMessage from '../../modules/ErrorMessage/ErrorMessage';
import DateWrapper from '../../components/DateWrapper/DateWrapper';
import FieldsetForm from '../../components/FieldsetForm/FieldsetForm';
import * as FindUserSelector from '../../selectors/findUser';
import * as FindUserActions from '../../actions/findUser';
import * as FindUserCreators from '../../creators/findUser';
import * as UserExplorerActions from '../../actions/userExplorer';
import * as AuthCreators from '../../creators/auth';

import State from '../../interfaces/states/State';

import './style.scss';

interface DispatchProps {
  authIdValue: (id: string) => void;
  getEmailValue: (email: string) => void;
  findUser: () => void;
  findUserInit: () => void;
  enableInputs: () => void;
  activeTabAction: (tab: number) => void;
  userExplorerInit: () => void;
  fetchRefreshAuth: (firstLoad: boolean) => void;
}

interface OwnProps {
  hideDatePicker: boolean;
  isErrorWhileSearch: boolean;
  userExplorerisSuccess: any[];
  currentCategory: any;
  isError: boolean;
  isLoading: boolean;
  onLogout: () => void;
  userExplorerFilter: (value: string, checked: boolean) => void;
  searchErrorInit: () => void;
}

interface Props extends DispatchProps, OwnProps {}

const SidePannel = (props: Props) => {

  const {
    hideDatePicker,
    userExplorerisSuccess,
    userExplorerFilter,
    currentCategory,
    onLogout,
    isErrorWhileSearch,
    searchErrorInit,
    enableInputs,
    isLoading,
    authIdValue,
    getEmailValue,
    fetchRefreshAuth,
    isError,
    activeTabAction,
  } = props;

  const setErrorTimeOut = () => {
    setTimeout(() => searchErrorInit(), 5000);
  };

  const history = useHistory();
  const [idField, setIdField] = React.useState(Const.EMPTY_FIELD);
  const [emailField, setEmailField] = React.useState(Const.EMPTY_FIELD);

  React.useEffect(() => {
    enableInputs();
  }, []);

  const onAuthIdFindVal = React.useCallback(e => setIdField(e.target.value.replace(/\D/g, '')), [idField]);

  const onEmailFindVal = React.useCallback(e => setEmailField(e.target.value), [emailField]);

  const findUserButtonClick = e => {
    e.preventDefault();

    if (idField) {
      authIdValue(idField);
      history.push({
        pathname: '/',
        search: `?id=${idField}`,
      });
    } else if (emailField) {
      getEmailValue(emailField);
      history.push({
        pathname: '/',
        search: `?email=${emailField}`,
      });
    }

    if (idField || emailField) {
      const isFirstPage = false;
      fetchRefreshAuth(isFirstPage);
      if (!isError) {
        return setTimeout(() => activeTabAction(Const.PERSONAL_ACTIVE_TAB), 3000);
      }
    } else {
      alert('You must fill at least one field!');
    }
  };

  const clearField = e => {
    if (e.target.id === Const.AUTH_ID) {
      setEmailField(Const.EMPTY_FIELD);
      getEmailValue(Const.EMPTY_FIELD);
    } else if (e.target.id === Const.EMAIL) {
      setIdField(Const.EMPTY_FIELD);
      authIdValue(Const.EMPTY_FIELD);
    }
  };

  const secondPageForm = [Const.AUTH_ID, Const.EMAIL];

  return(
    <div className='d-flex flex-column'>
      <button
        onClick={onLogout}
        className='primary-button search-text logout-button'>
        {'Logout'}
      </button>

      <form
        onSubmit={findUserButtonClick}
        className='second-page-form'>

        {secondPageForm.map((field, fieldIndex) => (
          <FieldsetForm
            key={fieldIndex}
            id={field}
            secondPage
            onFocus={clearField}
            disabled={isLoading}
            type={!fieldIndex ? 'text' : 'email'}
            placeholder={field}
            onChange={!fieldIndex ? onAuthIdFindVal : onEmailFindVal}
            fieldsetValue={!fieldIndex ? idField : emailField}
          />
        ))}

        <button
          onClick={findUserButtonClick}
          className='primary-button search-text search-secondform'>
          {'Search'}
        </button>

      </form>
      <Product>
        <ProductList />
      </Product>
      { !!isErrorWhileSearch && <ErrorMessage message='User is not found!' /> }

      { !!isErrorWhileSearch && setErrorTimeOut() }
      <DateWrapper
        hideDatePicker={hideDatePicker}
        userExplorerisSuccess={userExplorerisSuccess}
        userExplorerFilter={userExplorerFilter}
        currentCategory={currentCategory} />
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    isError: FindUserSelector.isError$(state),
    isLoading: FindUserSelector.isFindUserLoading$(state),
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    authIdValue: dispatchProps.authIdValue,
    getEmailValue: dispatchProps.getEmailValue,
    findUser: dispatchProps.findUser,
    findUserInit: dispatchProps.findUserInit,
    enableInputs: dispatchProps.enableInputs,
    activeTabAction: dispatchProps.activeTabAction,
    userExplorerInit: dispatchProps.userExplorerInit,
    fetchRefreshAuth: dispatchProps.fetchRefreshAuth,
    ...props,
  };
};

export default
connect(
  mapStateToProps, {
    authIdValue: FindUserActions.fetchFindUserAuthIdAction,
    getEmailValue: FindUserActions.fetchFindUserEmailAction,
    findUser: FindUserCreators.findUser,
    findUserInit: FindUserActions.fetchFindUserInitAction,
    enableInputs: FindUserActions.fetchFindUserEnableInputsAction,
    activeTabAction: FindUserActions.fetchActiveTabAction,
    userExplorerInit:  UserExplorerActions.fetchUserExplorerInitAction,
    fetchRefreshAuth: AuthCreators.fetchRefreshAuth,
  }, mergeProps
)(React.memo(SidePannel));
